"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var ButtonStyles = {
    width: 97,
    height: 42,
};
var ModalFooter = function (_a) {
    var isButtonDisabled = _a.isButtonDisabled, showTooltip = _a.showTooltip, onSave = _a.onSave;
    var SaveButtonTooltip = function () {
        return (react_1["default"].createElement(box_1["default"], { padding: "8px 4px" },
            "Save will be enabled once all",
            react_1["default"].createElement("br", null),
            "translations are added."));
    };
    var SaveButton = function () {
        return (react_1["default"].createElement(button_1["default"], { themed: true, variant: isButtonDisabled ? 'disabled' : 'primary', disabled: isButtonDisabled, onClick: isButtonDisabled ? null : onSave, style: ButtonStyles }, "Save"));
    };
    return (react_1["default"].createElement(box_1["default"], { padding: "0px 4px", marginLeft: "auto" }, showTooltip ? (react_1["default"].createElement(tooltip_1["default"], { themed: true, position: "TOP", size: "large", tooltip: react_1["default"].createElement(SaveButtonTooltip, null) },
        react_1["default"].createElement(SaveButton, null))) : (react_1["default"].createElement(SaveButton, null))));
};
exports["default"] = ModalFooter;
